import React from 'react';
import { Button } from '@mzc-pdc/ui';
import { ButtonProps } from './infrastructures/ButtonProps';

export const UndoButton = (props: ButtonProps) => (
  <Button
    variant={'outlined'}
    color={'secondary'}
    size={'medium'}
    disabled={props.disabled}
    onClick={props.onClick}
  >
    {props.children}
  </Button>
);
